import Model from "@/lib/model/model";
import request from "@/lib/request/request";

/**
 * 接口和前端组件化之后，组件相关的接口
 */
export default class ComponentConfig extends Model {
  // 组件信息保存(新)
  static exec(req: any) {
    return request
      .postComponentApi("v1/component/exec", req, false)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }

  // 组件信息保存(旧)
  static save(req: any) {
    return request
      .postComponentApi("v1/component/save", req, false)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }

  // 查询组件结果
  static result(sessionId: string) {
    return request
      .postComponentApi("v1/component/result", { sessionId }, false)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }
  // 查询组件配置
  static config(sessionId: string) {
    return request
      .postComponentApi("v1/component/config", { sessionId }, false)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }
}
